import { h } from 'preact';
import { EmptyState } from '../EmptyState';
import { Button } from '../Button';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'EmptyState',
  category: '📐 Layout',
  description: 'Estado vazio com ícone, título, descrição e CTA',
  usedIn: ['AgentesPage', 'Integrations', 'ChatHubPage'],
  example: () => (
    <EmptyState
      icon="(vazio)"
      title="Nenhum resultado"
      description="Tente ajustar os filtros de busca"
      action={<Button size="sm" variant="secondary">Limpar filtros</Button>}
    />
  ),
};
